export const colors = {
	primary: '#A9DDD6',
	secundary: '#4C6EF5',
	third: '#7950f2',
	succes: '#32936F',
	danger: '#E83F6F',
	warning: '#FFF275',
	dark: '#262730',
	light: '#FFF9FB',
	grey: '#D3D4D9',
	transparent: 'transparent',
};

export default {
	colors,
};
